import { HelpCircle } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";

const tooltipTriggerClass =
	"cursor-help text-fg-quaternary transition duration-200 hover:text-fg-quaternary_hover focus:text-fg-quaternary_hover";

export function EventFieldHelp({ text }: { text: string }) {
	return (
		<Tooltip placement="top" title={text}>
			<TooltipTrigger
				aria-label={text}
				className={tooltipTriggerClass}
				isDisabled={false}
			>
				<HelpCircle aria-hidden className="size-3.5 shrink-0" />
			</TooltipTrigger>
		</Tooltip>
	);
}
